// extracted by mini-css-extract-plugin
export var container = "_26-0";
export var error = "_26-9";
export var label = "_26-5";
export var light = "_26-6";
export var md = "_26-3";
export var sm = "_26-2";
export var thin = "_26-8";
export var thinBold = "_26-7";
export var vertical = "_26-4";
export var xs = "_26-1";